import {
  ApiResponse,
  BaseAPI,
  CommitFSCPaymentRequest,
  CommitResponseData,
  CreatePaymentResponseData,
  FailureReason,
  FCSPApi,
  InitiateFSCPaymentRequest,
  PaymentStatus,
} from '../../generated-sources/payments-api';
import { getRootHost } from '../util';

export class FakeFCSPApi extends BaseAPI implements FCSPApi {
  public async commitFSCPaymentRaw(
    requestParameters: CommitFSCPaymentRequest
  ): Promise<ApiResponse<CommitResponseData>> {
    let result: CommitResponseData = {
      expiryTime: new Date(),
      orderId: 'abc',
      status: PaymentStatus.Ok,
      reservationId: '123',
    };
    switch (requestParameters.authorization.toLowerCase()) {
      case 'bearer fail':
        result = {
          expiryTime: new Date(),
          orderId: 'abc',
          status: PaymentStatus.Failed,
          failureReason: FailureReason.InvalidCard,
          reservationId: '123',
        };
        break;
      case 'bearer low':
        result = {
          expiryTime: new Date(),
          orderId: 'abc',
          status: PaymentStatus.Failed,
          failureReason: FailureReason.InsufficientFunds,
          reservationId: '123',
        };
        break;
    }

    return {
      raw: new Response(),
      value: async () => result,
    };
  }
  public async commitFSCPayment(
    requestParameters: CommitFSCPaymentRequest
  ): Promise<CommitResponseData> {
    const apiResponse = await this.commitFSCPaymentRaw(requestParameters);
    return apiResponse.value();
  }
  public async initiateFSCPaymentRaw(
    requestParameters: InitiateFSCPaymentRequest
  ): Promise<ApiResponse<CreatePaymentResponseData>> {
    if (requestParameters.authorization.toLowerCase() === 'bearer success') {
      window.location.assign(`${getRootHost()}/checkout/auth?paymentToken=success`);
    }
    if (requestParameters.authorization.toLowerCase() === 'bearer success2') {
      window.location.assign(`${getRootHost()}/checkout/auth?paymentToken=low`);
    }

    const result: CreatePaymentResponseData =
      requestParameters.authorization.toLowerCase() === 'bearer fail'
        ? {
            adyenData: {
              resultCode: 'refused',
            },
          }
        : {
            adyenData: {
              resultCode: 'redirect-shopper',
            },
          };

    return {
      raw: new Response(),
      value: async () => result,
    };
  }
  public async initiateFSCPayment(
    requestParameters: InitiateFSCPaymentRequest
  ): Promise<CreatePaymentResponseData> {
    const apiResponse = await this.initiateFSCPaymentRaw(requestParameters);
    return apiResponse.value();
  }
}
